import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-play-circle-fill text-xl text-background-50"></i>
              </div>
              <span className="text-xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                桔子视频
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              桔子视频提供西瓜视频免费在线观看服务，高清全集不缓冲，电视剧大全电影免费看，满足您的高清视频需求。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-foreground-950 mb-4">视频分类</h3>
            <div className="grid grid-cols-2 gap-2">
              {categories.slice(0, 6).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Useful Links */}
          <div>
            <h3 className="text-sm font-semibold text-foreground-950 mb-4">常用链接</h3>
            <div className="space-y-2">
              <Link to="/about" className="block text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">
                关于我们
              </Link>
              <Link to="/category/all" className="block text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">
                全部视频
              </Link>
              <a href="#" className="block text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">
                帮助中心
              </a>
              <a href="#" className="block text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">
                用户协议
              </a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-semibold text-foreground-950 mb-4">联系我们</h3>
            <div className="space-y-2">
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-mail-line text-foreground-400"></i>
                <span>contact@juzivideo.com</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-phone-line text-foreground-400"></i>
                <span>400-888-9999</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-map-pin-line text-foreground-400"></i>
                <span>北京市朝阳区</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 桔子视频. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">
              服务条款
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">
              Cookie设置
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}